// extracted by mini-css-extract-plugin
export default {"link":"profile-page_link__yMWnc","twoFactorAuthLabel":"profile-page_twoFactorAuthLabel__vHnMw"};